import script from "./LinkColumn.vue?vue&type=script&lang=ts&setup=true"
export * from "./LinkColumn.vue?vue&type=script&lang=ts&setup=true"

import "./LinkColumn.vue?vue&type=style&index=0&id=9004691c&scoped=true&lang=css"

import exportComponent from "/builds/nmhwyAssu/0/batesbus/app.securechannel.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9004691c"]])

export default __exports__